// eslint-disable-next-line @typescript-eslint/no-require-imports
const plugins = [require('tailwindcss-padding-safe')];
export default plugins;
